import { AgMuiSelect2 } from "../mui-components/Controlled";
import { filtersState } from "../state/CommonState";

export function AgMobileUnitsBox({
    control,
    dis,
    isDimension,
    mode,
    showOnlyWeight = false,
    weightUnitName = "multidest.0.cargoDetails.0.weight.unit",
    weightUnitLabel,
    volumeUnitLabel,
    calculateWeightAndVolume,
    trigger
}) {
    const computedWeightLabel = weightUnitLabel || (
        isDimension
            ? (mode === "lcl" ? "Weight per package *" : "Weight Per Piece *")
            : "Total Weight *"
    );

    const computedVolumeLabel = volumeUnitLabel || (
        isDimension ? "Dimensions *" : "Total Volume *"
    );

    return (
        <div className="w-full flex flex-col gap-3 bg-white border border-[#E8E8E8] rounded-[10px] my-1">
            <div className="flex flex-row items-center">
                <span className="font-bold text-[#2C358A] text-sm">UNITS</span>
                <span className="font-normal text-[#5B6595] text-xs ml-1">(Applied to all Rows)</span>
            </div>
            <div className="w-full flex flex-row gap-3">
                <div className={`flex flex-col gap-1.5 ${showOnlyWeight ? "w-full" : "flex-1"}`}>
                    <label className="text-xs font-semibold text-[#2C358A]">{computedWeightLabel}</label>
                    <AgMuiSelect2
                        disabled={dis}
                        onChangeHandler={() => {
                            filtersState.initialize();
                            if (calculateWeightAndVolume) {
                                calculateWeightAndVolume();
                            }
                        }}
                        control={control}
                        name={weightUnitName}
                        size="small"
                        variant="outlined"
                        options={["Kgs", "Tons", "Lbs"]}
                        width="100%"
                        style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#333333",
                            height: "40px",
                            borderRadius: "8px"
                        }}
                        sx={{
                            width: "100%",
                            maxWidth: "100%",
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "8px",
                                height: "40px",
                                backgroundColor: "#FFFFFF",
                                "& fieldset": {
                                    borderColor: "#D4D4D4"
                                },
                                "&:hover fieldset": {
                                    borderColor: "#B0B0B0"
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#4CA7DC !important"
                                }
                            },
                            "& .MuiSelect-select": {
                                padding: "8px 12px",
                                display: "flex",
                                alignItems: "center"
                            }
                        }}
                    />
                </div>

                {!showOnlyWeight && (
                    <div className="flex flex-col gap-1.5 flex-1">
                        <label className="text-xs font-semibold text-[#2C358A]">
                            {computedVolumeLabel}
                        </label>
                        {isDimension ? (
                            <AgMuiSelect2
                                key="dimension"
                                disabled={dis}
                                onChangeHandler={async () => {
                                    filtersState.initialize();
                                    if (trigger) {
                                        await trigger(["multidest"]);
                                    }
                                }}
                                control={control}
                                name="cargoDimensionUnit"
                                size="small"
                                variant="outlined"
                                options={['Cms', 'MM', 'Inches', 'Meters', 'Feet']}
                                width="100%"
                                style={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    color: "#333333",
                                    height: "40px",
                                    borderRadius: "8px"
                                }}
                                sx={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "8px",
                                        height: "40px",
                                        backgroundColor: "#FFFFFF",
                                        "& fieldset": {
                                            borderColor: "#D4D4D4"
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#B0B0B0"
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#4CA7DC !important"
                                        }
                                    },
                                    "& .MuiSelect-select": {
                                        padding: "8px 12px",
                                        display: "flex",
                                        alignItems: "center"
                                    }
                                }}
                            />
                        ) : (
                            <AgMuiSelect2
                            key="volume"
                                disabled={dis}
                                onChangeHandler={() => {
                                    filtersState.initialize();
                                    if (calculateWeightAndVolume) {
                                        calculateWeightAndVolume();
                                    }
                                }}
                                control={control}
                                name="multidest.0.cargoDetails.0.totalVolume.unit"
                                size="small"
                                variant="outlined"
                                options={['CBM', 'cu ft']}
                                width="100%"
                                style={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    color: "#333333",
                                    height: "40px",
                                    borderRadius: "8px"
                                }}
                                sx={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "8px",
                                        height: "40px",
                                        backgroundColor: "#FFFFFF",
                                        "& fieldset": {
                                            borderColor: "#D4D4D4"
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#B0B0B0"
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#4CA7DC !important"
                                        }
                                    },
                                    "& .MuiSelect-select": {
                                        padding: "8px 12px",
                                        display: "flex",
                                        alignItems: "center"
                                    }
                                }}
                            />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
